"use client";
/**
 * Serviço para autenticação de usuários
 */

import {
  confirmEmailApi,
  recoverPasswordApi,
  impersonateUserApi,
  refreshTokenApi,
  selectInstanceApi,
  signInApi,
  signOutApi,
  signUpApi,
  unimpersonateUserApi,
  validateTokenApi,
} from "@/domains/auth/auth.api";
import {
  ConfirmEmailResponseType,
  ConfirmEmailType,
  ImpersonateResponseType,
  ImpersonateUserType,
  RecoverPasswordResponseType,
  RecoverPasswordType,
  SelectInstanceType,
  SignInResponseType,
  SignInType,
  SignUpType,
  UnimpersonateResponseType
} from "@/domains/auth/auth.type";

/**
 * Realiza o login do usuário
 * @param data Dados de login
 * @returns Resposta da API com os dados do usuário e token
 */
export async function signInService(data: SignInType): Promise<SignInResponseType> {
  return await signInApi(data);
}

/**
 * Realiza o cadastro do usuário
 * @param data Dados de cadastro
 * @returns Resposta da API com os dados do usuário e token
 */
export async function signUpService(data: SignUpType): Promise<SignInResponseType> {
  return await signUpApi(data);
}

/**
 * Envia o e-mail para recuperação de senha
 * @param data E-mail do usuário
 * @returns Resposta da API
 */
export async function recoverPasswordService(
  data: RecoverPasswordType
): Promise<RecoverPasswordResponseType> {
  return await recoverPasswordApi(data);
}

/**
 * Realiza o logout do usuário
 * @returns Resposta da API
 */
export async function signOutService(): Promise<{ status: string; message: string[] }> {
  return await signOutApi();
}

/**
 * Renova o token de acesso
 * @returns Resposta da API com novo token
 */
export async function refreshTokenService(): Promise<SignInResponseType> {
  return await refreshTokenApi();
}

/**
 * Valida o token de acesso
 * @returns Resposta da API
 */
export async function validateTokenService(): Promise<{ status: string; message: string[] }> {
  return await validateTokenApi();
}

/**
 * Seleciona uma instância para o usuário
 * @param data Dados da instância
 * @returns Resposta da API com os dados do usuário e token
 */
export async function selectInstanceService(data: SelectInstanceType): Promise<SignInResponseType> {
  return await selectInstanceApi(data);
}

/**
 * Personifica um usuário específico
 * @param data Dados de personificação (token e instance)
 * @returns Resposta da API com tokens e informações do usuário personificado
 */
export async function impersonateUserService(data: ImpersonateUserType): Promise<ImpersonateResponseType> {
  return await impersonateUserApi(data);
}

/**
 * Despersonifica o usuário atual e retorna ao usuário original
 * @returns Resposta da API com tokens do usuário original
 */
export async function unimpersonateUserService(): Promise<UnimpersonateResponseType> {
  return await unimpersonateUserApi();
}

/**
 * Confirma o email do usuário
 * @param data Token de confirmação
 * @returns Resposta da API
 */
export async function confirmEmailService(data: ConfirmEmailType): Promise<ConfirmEmailResponseType> {
  return await confirmEmailApi(data);
}
